export default __webpack_public_path__ + "static/media/roar.35a2a37c.jpg";